export default "__VITE_ASSET__DoSiIZXI__"